// extracted by mini-css-extract-plugin
module.exports = {"menu":"Sidebar-module--menu--32VYU","link":"Sidebar-module--link--23O2F","sub-link":"Sidebar-module--sub-link--2-Cbs","subLink":"Sidebar-module--sub-link--2-Cbs"};